import { getOwnerName } from '../../../common/store/members/members-selectors';
export const resolveReplyingToText = ({ targetComment, replyingToOwner, replyState, t, }) => {
    const replyingToStatus = 'targetStatus' in replyState ? replyState.targetStatus : undefined;
    if (targetComment?.status === 'DELETED' ||
        targetComment?.status === 'HIDDEN' ||
        replyingToStatus === 'DELETED' ||
        replyingToStatus === 'HIDDEN') {
        return t('comment.replying-to.deleted-comment');
    }
    return getOwnerName(replyingToOwner, t);
};
//# sourceMappingURL=reply-state-switch-utils.js.map